<desy-search-bar
  #searchBarRef
  classes="flex-1 mt-4"
  [placeholder]="placeholder"
  [id]="'search-bar-adhesions'"
  (search)="stopNativeSearch($event)"
  (keyup)="onSearchInput(searchBarRef.value)"
  (keydown)="onKeyDown($event, searchBarRef.value)"
  (clickEvent)="onSearchBarClick(searchBarRef.value)">
  <desy-button
    *ngIf="showExternalButton"
    [classes]="externalButtonPrimary ? 'c-button--primary' : 'c-button--secondary'"
    (clickEvent)="onExternalButtonClick(searchBarRef.value)">
    Buscar
  </desy-button>
</desy-search-bar>
